import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { TbToastService } from 'src/app/shared/services/tb-toast.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PushNotificationRealtimeService {
    public data: any;
    public bradcastedData: any[];
    constructor(public toast: TbToastService) { }

    private hubConnection: signalR.HubConnection

    public startPushNotificationServices(userId: string) {
        this.startConnection();
        this.addTransferNotificaionDataListener(userId);
    }

    public startConnection = () => {
        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${environment.realTimeAPIRoot}/pushnotification`)
            .withAutomaticReconnect()
            .build();

        this.hubConnection
            .start()
            .catch(err => console.log('Error starting notification connection: ' + err))
    }

    public addTransferNotificaionDataListener = (userId) => {
        this.hubConnection.on(`transferpushnotification-${userId}`, (data) => {
            this.data = data;
            this.toast.showToast(data.type, data.message, data.title, 100000);
        });
    }

    public stopConnection() {
        this.hubConnection.stop()
    }

}